<template>
    <div v-bind:class="{ 'bg-header': hasBreadCrumbs }">
        <nav class="navbar navbar-expand-lg bg-sea-blue" style="justify-content: space-between;">

            <router-link class="navbar-brand" to="/">
                <img src="/wwwroot/images/FFLLogo.png" alt="images" style="height: 60px; min-width: 200px;">
            </router-link>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon">
                    <i class="fa fa-bars"></i>
                </span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="isAuthenticated">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == '') }">
                        <router-link class="nav-link" to="/">Home</router-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'Courses') }">
                        <router-link class="nav-link" to="/admin/courses">Courses</router-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'AdminCoursePackages') }" v-show="userRole == 'admin'">
                        <router-link class="nav-link" to="/admin/coursePackages">Course Packages</router-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'AdminUsers') }">
                        <router-link class="nav-link" to="/admin/users">Users</router-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'AdminSites') }" v-show="userRole == 'admin'">
                        <router-link class="nav-link" to="/admin/sites">Sites</router-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'AdminPayments') }">
                        <router-link class="nav-link" to="/admin/payments">Payments</router-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ 'active': (currentPageName == 'AdminCoupons') }">
                        <router-link class="nav-link" to="/admin/coupons">Coupons</router-link>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-uppercase" v-on:click="logout">Log out</a>
                        <!--<router-link class="nav-link" to="/auth/login">Logout</router-link>-->
                    </li>
                </ul>

                <!--debug-->
                <!--<div class="user-info" v-if="user && isAuthenticated">
                    <p>Username: {{user.firstName}} {{user.lastName}}</p>
                    <p>Email: {{user.email}}</p>
                    <p>SiteId: {{user.siteId}}</p>
                    <p>Id: {{user.id}}</p>
                </div>-->
            </div>
            <div v-else>
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link class="nav-link text-uppercase" to="/auth/login">Log In</router-link>
                    </li>
                </ul>
            </div>
        </nav>
        <div v-if="hasBreadCrumbs" class="flat-header-blog">
            <div class="page-title page-title-blog">
                <div class="page-title-inner">
                    <div class="breadcrumbs breadcrumbs-blog text-left">
                        <div class="container-fluid ml-2">
                            <div class="breadcrumbs-wrap">
                                <ul class="breadcrumbs-inner">
                                    <li>
                                        <router-link to="/">Home</router-link>
                                    </li>

                                    <li v-for="(key, val) in breadCrumbs">
                                        <router-link :to="val">{{ key }}</router-link>
                                    </li>
                                </ul>
                                <!--<div class="title">
                                    {{ currentPageName }}
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .bg-header{
        padding-bottom: 5px;
    }

    .nav-link {
        font-size: 18px;
        margin-right: 0.6rem;
    }

    .nav-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        text-align: center;
    }

    .nav-item a {
        color: #282D69 !important;
    }

        .nav-item a:hover {
            color: white !important;
        }

    .active a {
        color: white !important;
        border-bottom: 1px solid white;
    }
</style>

<script>

    export default {
        name: 'HeaderComponent',
        data() {
            return {
                user: null,
            }
        },
        methods: {
            logout: function () {
                this.$store.commit("setUserState", null);
                this.$router.push("/auth/login");
            }
        },
        watch: {
            userState: function (newVal, oldVal) {
                this.user = newVal;
            }
        },
        computed: {
            isAuthenticated() {
                var auth = this.$store.getters.userAuthenticated;
                return auth;
            },
            userRole() {
                var roles = this.$store.state.user.roles;
                if (roles) {
                    return roles[0];
                }
            },
            userState() {
                var user = this.$store.getters.getUser;
                return user;
            },
            breadCrumbs() {
                return this.$store.state.breadCrumbs;
            },
            hasBreadCrumbs() {
                var breadCrumbs = this.$store.state.breadCrumbs;
                return breadCrumbs && Object.keys(breadCrumbs).length > 0;
            },
            currentPageName() {

                if (this.breadCrumbs == null)
                    return "";

                var keys = Object.keys(this.breadCrumbs);
                var lastKey = keys[keys.length - 1];
                var lastName = this.breadCrumbs[lastKey];

                return lastName;
            },
            cart() {
                return this.$store.state.cart
            }
        },
        mounted() {
            this.user = this.userState;
        }
    }
</script> 